import React, { useState, useEffect, useRef } from 'react';
import PocketBase from 'pocketbase';
import Header from './Header'; 
import Footer from './Footer'; 

import iconBuy from './assets/buy.png';
import iconSell from './assets/sell.png';
import iconNew from './assets/new_arrivals.jpg';
import iconList from './assets/list_car.jpg';
import iconDrive from './assets/test_drive.png';
import iconMore from './assets/more.svg';
import iconInsurance from './assets/insurance.jpg';
import iconChallan from './assets/challan.jpg';
import iconRto from './assets/rto.webp';
import iconRc from './assets/rc.webp';
import iconService from './assets/service.jpeg';

import CheckoutPage from './pages/checkout_page'; 
import BuyUsedCar from './pages/Buy_Used_Car';
import Blogs from './pages/blogs';
import EMICalculator from './pages/EMI_Calculator';
import AboutUs from './pages/About_Us';
import FAQ from './pages/FAQ';
import TermsAndCondition from './pages/Terms_and_condition';
import PrivacyPolicy from './pages/Privacy_Policy';
import Career from './pages/Career';
import ContactUs from './pages/Contact_Us';
import InspectionProcess from './pages/Inspection_Process';

import Admin from './pages/admin';
import Account from './pages/account';

// 🚨 Mobile Pages & Navigation Imports 🚨
import MobileBottomNav from './MobileBottomNav';
import MobileHome from './mobile_pages/MobileHome';
import MobileBuyCar from './mobile_pages/MobileBuyCar';
import MobileSellCar from './mobile_pages/MobileSellCar';
import MobileExplore from './mobile_pages/MobileExplore';
import MobileAccount from './mobile_pages/MobileAccount';
import MobileAdminPage from './mobile_pages/MobileAdminPage';
import MobileCheckoutPage from './mobile_pages/MobileCheckoutPage';
import CompareCars from './mobile_pages/CompareCars';
import MobileDashboard from './mobile_pages/MobileDashboard';
import MobileCarDetails from './mobile_pages/MobileCarDetails';

const pb = new PocketBase('https://bahcarplaza.com');

const BANNER_IMAGES = [
  "https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?auto=format&fit=crop&q=80&w=1920",
  "https://wallpapercave.com/wp/wp9073965.jpg",
  "https://wallpapercave.com/wp/wp3897203.jpg",
  "https://blog.sothebysrealty.co.uk/hs-fs/hubfs/Imported_Blog_Media/lam-jpg.jpg?width=1600&height=1133&name=lam-jpg.jpg" 
];

const BRAND_LOGOS = {
  'Maruti Suzuki': 'https://i.pinimg.com/1200x/f1/04/16/f1041698a90aea121f8da53acf1a8f92.jpg',
  'Hyundai': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Hyundai_Motor_Company_logo.svg/2048px-Hyundai_Motor_Company_logo.svg.png',
  'Honda': 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Honda_Logo.svg/2048px-Honda_Logo.svg.png',
  'Tata': 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Tata_logo.svg/2048px-Tata_logo.svg.png',
  'Mahindra': 'https://i.pinimg.com/1200x/17/38/ff/1738ff204f7eaaf912742070a0871f8e.jpg',
  'Toyota': 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Toyota_carlogo.svg/2048px-Toyota_carlogo.svg.png',
  'Kia': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/KIA_logo2.svg/2048px-KIA_logo2.svg.png',
  'Ford': 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Ford_Motor_Company_Logo.svg/2048px-Ford_Motor_Company_Logo.svg.png',
  'Volkswagen': 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Volkswagen_logo_2019.svg/2048px-Volkswagen_logo_2019.svg.png',
  'BMW': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/BMW.svg/2048px-BMW.svg.png',
  'Mercedes': 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Mercedes-Logo.svg/2048px-Mercedes-Logo.svg.png',
  'Audi': 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Audi-Logo_2016.svg/2048px-Audi-Logo_2016.svg.png',
};

function App() {
  const [cars, setCars] = useState([]);
  const [videosList, setVideosList] = useState([]); 
  const [view, setView] = useState('home'); 
  
  const [selectedCar, setSelectedCar] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [cityFilter, setCityFilter] = useState("");
  const [activeTab, setActiveTab] = useState('My Bookings');

  const [authData, setAuthData] = useState({ email: '', password: '', name: '', phone: '' });
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState('');
  const [enteredOtp, setEnteredOtp] = useState('');

  const [showBookingModal, setShowBookingModal] = useState(false);
  const [bookingData, setBookingData] = useState({
    full_name: '', phone: '', booking_date: '', visit_type: 'Test Drive', message: ''
  });

  const [feedbacks, setFeedbacks] = useState([]);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [newFeedback, setNewFeedback] = useState("");

  const [cardImageIndex, setCardImageIndex] = useState({});
  const [detailsImageIndex, setDetailsImageIndex] = useState(0);
  const [bannerIndex, setBannerIndex] = useState(0);

  const [showMobileMoreMenu, setShowMobileMoreMenu] = useState(false);
  const [showBrandsModal, setShowBrandsModal] = useState(false); 

  const videoScrollRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleTouchStart = (e) => { touchStartX.current = e.targetTouches[0].clientX; };
  const handleTouchMove = (e) => { touchEndX.current = e.targetTouches[0].clientX; };
  const handleTouchEnd = (e, carId, totalImages) => {
    if (totalImages <= 1) return; 
    const swipeThreshold = 40; 
    if (touchStartX.current - touchEndX.current > swipeThreshold) {
      handleCardImageChange({ stopPropagation: () => {} }, carId, totalImages, 1);
    }
    if (touchEndX.current - touchStartX.current > swipeThreshold) {
      handleCardImageChange({ stopPropagation: () => {} }, carId, totalImages, -1);
    }
    touchStartX.current = 0;
    touchEndX.current = 0;
  };

  const detailsTouchStartX = useRef(0);
  const detailsTouchEndX = useRef(0);
  const handleDetailsTouchStart = (e) => { detailsTouchStartX.current = e.targetTouches[0].clientX; };
  const handleDetailsTouchMove = (e) => { detailsTouchEndX.current = e.targetTouches[0].clientX; };
  const handleDetailsTouchEnd = (totalImages) => {
    if (totalImages <= 1) return;
    const swipeThreshold = 40;
    if (detailsTouchStartX.current - detailsTouchEndX.current > swipeThreshold) {
      setDetailsImageIndex((prev) => (prev + 1) % totalImages); 
    }
    if (detailsTouchEndX.current - detailsTouchStartX.current > swipeThreshold) {
      setDetailsImageIndex((prev) => (prev - 1 + totalImages) % totalImages); 
    }
    detailsTouchStartX.current = 0;
    detailsTouchEndX.current = 0;
  };

  const scrollVideos = (direction) => {
    if (videoScrollRef.current) {
      const scrollAmount = direction === 'left' ? -320 : 320; 
      videoScrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  // ==========================================
  // 🚨 NATIVE WINDOW.HISTORY ROUTING (FIXED) 🚨
  // ==========================================
  const navigateTo = (newPage) => {
    if (newPage !== view) {
      // Push state to browser natively
      window.history.pushState({ page: newPage }, '');
      setView(newPage);
    }
    setShowMobileMoreMenu(false);
    setShowBrandsModal(false);
    window.scrollTo(0, 0); 
  };

  const goBack = () => {
    // Uses native browser back, fully syncs with Android Hardware button!
    window.history.back();
  };

  useEffect(() => {
    // Set initial state
    window.history.replaceState({ page: view }, '');
    
    const handlePopState = (event) => {
      if (!event.state || !event.state.moreMenuOpen) setShowMobileMoreMenu(false);
      if (!event.state || !event.state.brandsModalOpen) setShowBrandsModal(false);
      
      // If native back button is pressed, read the page from history
      if (event.state && event.state.page) {
        setView(event.state.page);
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const openMoreMenu = () => {
    setShowMobileMoreMenu(true);
    window.history.pushState({ page: view, moreMenuOpen: true }, '');
  };

  const closeMoreMenu = () => {
    setShowMobileMoreMenu(false);
    if (window.history.state && window.history.state.moreMenuOpen) window.history.back();
  };

  const openBrandsModal = () => {
    setShowBrandsModal(true);
    window.history.pushState({ page: view, brandsModalOpen: true }, '');
  };

  const closeBrandsModal = () => {
    setShowBrandsModal(false);
    if (window.history.state && window.history.state.brandsModalOpen) window.history.back();
  };

  const fetchCars = async () => {
    try { const records = await pb.collection('cars').getFullList({ expand: 'added_by', sort: '-created' }); setCars(records); } 
    catch (e) { console.error(e); }
  };

  const fetchFeedbacks = async () => {
    try { const records = await pb.collection('user_feedback').getFullList({ sort: '-created', expand: 'user_id' }); setFeedbacks(records); } 
    catch (e) { console.error(e); }
  };

  const fetchVideos = async () => {
    try { const records = await pb.collection('videos_list').getFullList({ sort: '-created' }); setVideosList(records); } 
    catch (e) { console.error(e); }
  };

  useEffect(() => {
    fetchCars(); fetchFeedbacks(); fetchVideos();
    const interval = setInterval(() => { fetchCars(); fetchFeedbacks(); fetchVideos(); }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const bannerInterval = setInterval(() => {
      setBannerIndex((prevIndex) => (prevIndex + 1) % BANNER_IMAGES.length);
    }, 4000);
    return () => clearInterval(bannerInterval);
  }, []);

  useEffect(() => {
    setDetailsImageIndex(0);
    if (selectedCar && pb.authStore.isValid) {
      const trackCarView = async () => {
        try {
          await pb.collection('cars_view').create({ user_id: pb.authStore.model.id, car_id: selectedCar.id });
          const user = pb.authStore.model;
          const car = selectedCar;
          const time = new Date().toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' });
          const carLink = `https://bahcarplaza.com`;
          const telegramMessage = `🚨 *New Car Visit Alert!* 🚨\n\n👤 *Customer:* ${user.name || 'N/A'}\n📧 *Email:* ${user.email || 'N/A'}\n📞 *Phone:* ${user.phone || 'N/A'}\n\n🚗 *Car:* ${car.brand} ${car.model}\n💰 *Price:* ₹${car.price?.toLocaleString()}\n🗓️ *Time:* ${time}\n🔗 *Link:* ${carLink}`;
          
          const botToken = "8655064447:AAF6UfdI8aKRSwQiTlrTlAkAvSUGjaUVpOU"; 
          const chatId = "8664366749";
          const telegramUrl = `https://api.telegram.org/bot${botToken}/sendMessage`;

          fetch(telegramUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', }, body: JSON.stringify({ chat_id: chatId, text: telegramMessage, parse_mode: 'Markdown' }) })
          .catch(error => console.error("Telegram API Error:", error));
        } catch (error) { console.error("Error tracking car view:", error); }
      };
      trackCarView();
    }
  }, [selectedCar]);

  const getVal = (val) => (Array.isArray(val) ? val[0] : val || "");
  const getImages = (val) => Array.isArray(val) ? val : (val ? [val] : []);

  const handleCardImageChange = (e, carId, total, direction) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setCardImageIndex(prev => {
      const current = prev[carId] || 0;
      return { ...prev, [carId]: (current + direction + total) % total };
    });
  };

  const handleAuthSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isLoginMode) {
        await pb.collection('users').authWithPassword(authData.email, authData.password);
        alert("Welcome to Bah! Car Plaza!");
        navigateTo('home'); window.location.reload(); 
      } else {
        if (!isOtpSent) {
          if (authData.phone.length !== 10) { alert("Please enter a valid 10-digit phone number."); return; }
          const otp = Math.floor(100000 + Math.random() * 900000).toString();
          setGeneratedOtp(otp); setIsOtpSent(true);
          alert(`[TESTING MODE]\nAn OTP has been sent to +91 ${authData.phone}.\n\nYour OTP is: ${otp}\n\n(Note: This is a simulated SMS for testing. Real SMS requires an API like Fast2SMS)`);
        } else {
          if (enteredOtp !== generatedOtp) { alert("❌ Invalid OTP! Please check and try again."); return; }
          await pb.collection('users').create({ email: authData.email, password: authData.password, passwordConfirm: authData.password, name: authData.name, phone: authData.phone });
          alert("✅ Account Created Successfully! Please login to continue.");
          setIsLoginMode(true); setIsOtpSent(false); setEnteredOtp('');
        }
      }
    } catch (e) { alert("Auth Error: " + (e.data?.message || e.message)); }
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();
    try {
      await pb.collection('bookings').create({
        ...bookingData, phone: bookingData.phone.toString(), booking_date: new Date(bookingData.booking_date).toISOString(),
        car_id: selectedCar.id, status: 'Pending', user_id: pb.authStore.model?.id
      });
      alert("Booking Request Sent!"); setShowBookingModal(false); 
    } catch (e) { alert("Error: " + e.message); }
  };

  const handleFeedbackSubmit = async (e) => {
    e.preventDefault();
    if (!pb.authStore.isValid) { alert("Please login to give feedback."); navigateTo('auth'); setShowFeedbackModal(false); return; }
    if (newFeedback.trim().length < 5) { alert("Feedback must be at least 5 characters long."); return; }
    try {
      await pb.collection('user_feedback').create({ feedback_text: newFeedback, user_id: pb.authStore.model.id });
      alert("Thank you for your valuable feedback!");
      setNewFeedback(""); setShowFeedbackModal(false); fetchFeedbacks();
    } catch (e) { alert("Error submitting feedback: " + e.message); }
  };

  const handleBuyNowSubmit = () => {
    if (!pb.authStore.isValid) { 
      alert("Please login first to proceed to checkout."); 
      navigateTo('auth'); 
      return; 
    }
    navigateTo('checkout_page'); 
  };

  const handleDirectBuy = (carToBuy) => {
    if (carToBuy.status === 'Sold') return;
    if (!pb.authStore.isValid) { 
      alert("Please login first to proceed to checkout."); 
      navigateTo('auth'); 
      return; 
    }
    setSelectedCar(carToBuy);
    navigateTo('checkout_page'); 
  };

  const handleAddToWishlist = async (carId) => {
    if (!pb.authStore.isValid) return alert("Please log in to add to wishlist.");
    try { await pb.collection('wishlist').create({ user_id: pb.authStore.model?.id, car_id: carId }); alert("Added to Wishlist!"); } 
    catch (e) { alert("Already in wishlist or error occurred."); }
  };

  const approvedCars = cars.filter(car => car.status === 'Approved');
  
  const soldOutCars = cars.filter(car => car.status === 'Sold')
    .sort((a, b) => new Date(b.updated) - new Date(a.updated))
    .slice(0, 15);

  const filteredCars = approvedCars.filter(car =>
    (car.brand?.toLowerCase().includes(searchTerm.toLowerCase()) || car.model?.toLowerCase().includes(searchTerm.toLowerCase())) &&
    (cityFilter === "" || getVal(car.city) === cityFilter)
  );

  const homepageCars = filteredCars.slice(0, 30);

  const oneMonthAgo = new Date();
  oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
  const newArrivalCars = approvedCars.filter(car => new Date(car.created) >= oneMonthAgo);

  const brandCounts = {};
  Object.keys(BRAND_LOGOS).forEach(brand => { brandCounts[brand] = 0; });
  approvedCars.forEach(car => {
    const brand = car.brand;
    if (brand) {
      if (brandCounts[brand] === undefined) brandCounts[brand] = 0;
      brandCounts[brand]++;
    }
  });

  const allBrands = Object.keys(brandCounts)
    .map(brand => ({ name: brand, count: brandCounts[brand], logo: BRAND_LOGOS[brand] || 'https://cdn-icons-png.flaticon.com/512/3202/3202926.png' }))
    .sort((a, b) => b.count - a.count); 

  const topPopularBrands = allBrands.slice(0, 5);

  const handleBrandClick = (brandName) => {
    setSearchTerm(brandName);
    navigateTo('buy');
    if(showBrandsModal) closeBrandsModal();
  };

  const inputStyle = { padding: '15px', borderRadius: '15px', border: '1px solid #eee', backgroundColor: '#f9f9f9', fontWeight: 'bold', width: '100%', boxSizing: 'border-box' };

  const handleQuickAction = (actionType) => {
    switch(actionType) {
      case 'buy': navigateTo('buy'); break;
      case 'sell': navigateTo('sell_car_new'); break;
      case 'new-arrivals': navigateTo('new-arrivals'); break;
      case 'list-car': 
        if(pb.authStore.isValid) { navigateTo('sell_car_new'); } 
        else { alert("Please login to list your car."); navigateTo('auth'); }
        break;
      case 'test-drive': 
        document.getElementById('explore-brands')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if(showMobileMoreMenu) closeMoreMenu();
        break;
      case 'insurance': window.open('https://www.carinfo.app/car-insurance', '_blank'); break;
      case 'challan': window.open('http://sanjog.wb.gov.in/payFine', '_blank'); break;
      case 'rto': window.open('https://carinfo.app/rto-vehicle-registration-details/west-bengal', '_blank'); break;
      case 'rc': window.open('https://www.carinfo.app/rc-details/', '_blank'); break;
      case 'service': window.open('https://carinfo.app/service-history?utm_medium=rc_search&utm_source=carinfoWeb&utm_term=top_services', '_blank'); break;
      default: break;
    }
  };

  const ActionItem = ({ label, icon, actionType }) => (
    <div onClick={() => handleQuickAction(actionType)} className="bg-white rounded-xl p-1 md:p-1 flex flex-col items-center justify-center border border-gray-100 shadow-[0_2px_8px_rgba(0,0,0,0.04)] cursor-pointer active:scale-100 transition-transform hover:shadow-md">
      <img src={icon} alt={label} className="w-[90px] h-[60px] object-contain mb-1 drop-shadow-sm" />
      <span className="text-[10px] font-black text-[#002f34] text-center leading-tight whitespace-nowrap overflow-hidden text-ellipsis w-full">{label}</span>
    </div>
  );

  // ============================================
  // 🚨 ROUTING & MOBILE CONDITIONAL RENDERING 🚨
  // ============================================

  if (view === 'auth') {
    return (
      <div className="flex justify-center items-center min-h-screen bg-[#f1f4f8] p-4 font-sans">
        <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } } .animate-fadeIn { animation: fadeIn 0.4s ease forwards; }`}</style>
        <div className="bg-white p-8 md:p-12 rounded-3xl w-full max-w-[450px] shadow-2xl">
          <h2 className="text-center text-[#002f34] font-black text-2xl md:text-3xl mb-2">{isLoginMode ? 'Welcome Back!' : 'Create Account'}</h2>
          <p className="text-center text-gray-500 text-xs md:text-sm mb-8">{isLoginMode ? 'Login to manage your cars and bookings.' : 'Join the best car marketplace today.'}</p>
          <form onSubmit={handleAuthSubmit} className="flex flex-col gap-4">
            {!isOtpSent && (
              <>
                {!isLoginMode && (
                  <>
                    <input required style={inputStyle} type="text" placeholder="Full Name" onChange={e => setAuthData({...authData, name: e.target.value})} />
                    <input required style={inputStyle} type="number" placeholder="Phone Number (10 Digits)" onChange={e => setAuthData({...authData, phone: e.target.value})} />
                  </>
                )}
                <input required style={inputStyle} type="email" placeholder="Email Address" onChange={e => setAuthData({...authData, email: e.target.value})} />
                <input required style={inputStyle} type="password" placeholder="Password (Min 8 chars)" minLength="8" onChange={e => setAuthData({...authData, password: e.target.value})} />
              </>
            )}

            {!isLoginMode && isOtpSent && (
              <div className="flex flex-col gap-3 animate-fadeIn p-4 bg-[#f9f9f9] rounded-2xl border border-gray-100">
                <p className="text-sm font-bold text-[#002f34] text-center m-0">OTP sent to +91 {authData.phone}</p>
                <input required style={{ ...inputStyle, textAlign: 'center', letterSpacing: '8px', fontSize: '22px', backgroundColor: '#fff' }} type="number" placeholder="------" maxLength="6" onChange={e => setEnteredOtp(e.target.value)} />
                <button type="button" onClick={() => setIsOtpSent(false)} className="text-xs text-[#ef5e33] font-bold bg-transparent border-none cursor-pointer mt-1 hover:underline">Change Details</button>
              </div>
            )}
            <button type="submit" className="p-4 bg-[#ef5e33] text-white rounded-2xl font-black text-sm md:text-base mt-2 shadow-lg hover:bg-[#d94f29] transition-colors uppercase tracking-wide">
              {isLoginMode ? 'LOGIN TO ACCOUNT' : (!isOtpSent ? 'SEND OTP' : 'VERIFY & SIGN UP')}
            </button>
          </form>
          {!isOtpSent && (
            <p onClick={() => { setIsLoginMode(!isLoginMode); setAuthData({ email: '', password: '', name: '', phone: '' }); }} className="text-center mt-6 cursor-pointer text-[#002f34] font-bold text-sm hover:text-[#ef5e33] transition-colors">
              {isLoginMode ? "Don't have an account? Sign Up" : "Already have an account? Login"}
            </p>
          )}
          <div className="text-center mt-4">
            <button onClick={goBack} className="bg-transparent border-none text-gray-400 font-bold underline text-xs cursor-pointer hover:text-gray-600 transition-colors">Return</button>
          </div>
        </div>
      </div>
    );
  }

  if (view === 'account') {
    if (isMobile) {
      return (
        <>
          <MobileAccount view={view} setView={navigateTo} goBack={goBack} setSelectedCar={setSelectedCar} activeTab={activeTab} setActiveTab={setActiveTab} />
          <MobileBottomNav view={view} setView={navigateTo} activeTab={activeTab} setActiveTab={setActiveTab} />
        </>
      );
    }
    return <Account view={view} setView={navigateTo} setSelectedCar={setSelectedCar} activeTab={activeTab} setActiveTab={setActiveTab} />;
  }

  if (view === 'compare') {
    if (isMobile) {
      return (
        <>
          <CompareCars view={view} setView={navigateTo} goBack={goBack} cars={cars} setSelectedCar={setSelectedCar} selectedCar={selectedCar} />
          <MobileBottomNav view={view} setView={navigateTo} activeTab={activeTab} setActiveTab={setActiveTab} />
        </>
      );
    }
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
        <Header view={view} setView={navigateTo} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />
        <div className="flex-1 flex flex-col items-center justify-center p-6 text-center">
           <h2 className="text-3xl font-black text-[#002f34] mb-2 uppercase">Compare Cars</h2>
           <p className="text-gray-500 font-bold mb-8">Desktop version is coming soon.</p>
           <button onClick={goBack} className="bg-[#ef5e33] text-white px-8 py-3 rounded-full font-black uppercase shadow-lg border-none cursor-pointer">← Go Back</button>
        </div>
        <Footer setView={navigateTo} />
      </div>
    );
  }

  if (view === 'dashboard') {
    if (isMobile) {
      return (
        <>
          <MobileDashboard view={view} setView={navigateTo} goBack={goBack} setActiveTab={setActiveTab} />
          <MobileBottomNav view={view} setView={navigateTo} activeTab={activeTab} setActiveTab={setActiveTab} />
        </>
      );
    }
    return <Account view={'account'} setView={navigateTo} setSelectedCar={setSelectedCar} activeTab={activeTab} setActiveTab={setActiveTab} />;
  }


  if (view === 'sell_car_new') {
    if (isMobile) {
      return (
        <>
          <MobileSellCar view={view} setView={navigateTo} goBack={goBack} setActiveTab={setActiveTab} />
          <MobileBottomNav view={view} setView={navigateTo} activeTab={activeTab} setActiveTab={setActiveTab} />
        </>
      );
    }
    
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
        <Header view={view} setView={navigateTo} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />
        <div className="flex-1 flex flex-col items-center justify-center p-6 text-center">
           <img src="https://cdn-icons-png.flaticon.com/512/8703/8703080.png" className="w-24 h-24 mb-6 opacity-50" alt="Sell Car" />
           <h2 className="text-3xl font-black text-[#002f34] mb-2 uppercase">Sell Car Page</h2>
           <p className="text-gray-500 font-bold mb-8">This page is currently under construction. Please check back later!</p>
           <button onClick={goBack} className="bg-[#ef5e33] text-white px-8 py-3 rounded-full font-black uppercase shadow-lg border-none cursor-pointer">← Go Back</button>
        </div>
        <Footer setView={navigateTo} />
      </div>
    );
  }
  
  if (view === 'mobile_admin') {
  return <MobileAdminPage view={view} setView={navigateTo} goBack={goBack} setSelectedCar={setSelectedCar} />;
}

  if (view === 'admin') {
    if (pb.authStore.isValid && ['nabojyoti46@gmail.com', 'admin@test.com'].includes(pb.authStore.model?.email)) { 
      return <Admin view={view} setView={navigateTo} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setSelectedCar={setSelectedCar} />;
    } else {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#f1f4f8] p-4 font-sans text-center">
          <h2 className="text-5xl mb-4">🛑</h2>
          <h2 className="text-[#002f34] font-black text-2xl md:text-3xl mb-3">Access Denied!</h2>
          <p className="text-gray-500 mb-6 text-sm md:text-base">You do not have permission to view the admin panel.</p>
          <button onClick={goBack} className="px-6 py-3 bg-[#ef5e33] text-white rounded-full font-bold cursor-pointer hover:bg-[#d94f29] transition-colors">Go Back</button>
        </div>
      );
    }
  }
  
  if (view === 'checkout_page') {
    if (isMobile) {
      return <MobileCheckoutPage setView={navigateTo} goBack={goBack} selectedCar={selectedCar} setActiveTab={setActiveTab} />;
    } else {
      return <CheckoutPage setView={navigateTo} selectedCar={selectedCar} setActiveTab={setActiveTab} />;
    }
  }

  // 🚨 DETAILS PAGE RENDERING UPDATE 🚨
  if (view === 'details' && selectedCar) {
    if (isMobile) {
      return (
        <MobileCarDetails 
          car={selectedCar} 
          setView={navigateTo} 
          goBack={goBack}
          cars={cars} 
          setSelectedCar={setSelectedCar} 
        />
      );
    }
  }

  if (view === 'new-arrivals') {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
        <Header view={view} setView={navigateTo} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />
        <main className="max-w-[1600px] w-full mx-auto py-10 px-4 md:px-8 flex-1">
          <div className="flex items-center gap-4 mb-8">
             <button onClick={goBack} className="bg-transparent border-none text-[#ef5e33] font-black text-sm cursor-pointer hover:underline">← Back</button>
             <h2 className="text-2xl md:text-3xl font-black text-[#002f34] uppercase italic m-0">New <span className="text-[#ef5e33]">Arrivals</span></h2>
          </div>
          
          {newArrivalCars.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-6">
              {newArrivalCars.map((car) => {
                const images = getImages(car.image);
                const currentIndex = cardImageIndex[car.id] || 0;

                return (
                  <div key={car.id} onClick={() => { setSelectedCar(car); navigateTo('details'); }} className="bg-white p-3 rounded-[1.5rem] md:rounded-[2rem] shadow-md hover:shadow-2xl transition-all duration-300 group relative flex flex-col cursor-pointer hover:-translate-y-2">
                    <div 
                      className="h-40 md:h-44 rounded-[1rem] md:rounded-[1.5rem] mb-3 overflow-hidden relative group/slider"
                      onTouchStart={handleTouchStart}
                      onTouchMove={handleTouchMove}
                      onTouchEnd={(e) => handleTouchEnd(e, car.id, images.length)}
                    >
                      <img src={`https://bahcarplaza.com/api/files/${car.collectionId}/${car.id}/${images[currentIndex]}`} className="w-full h-full object-cover group-hover:scale-110 transition duration-700" alt="car" />
                      
                      <div className="absolute top-3 left-3 bg-[#1db954] text-white text-[9px] font-black px-2 py-1 rounded-md uppercase tracking-wider shadow-md z-20">New</div>
                      <button onClick={(e) => { e.stopPropagation(); handleAddToWishlist(car.id); }} className="absolute top-3 right-3 bg-transparent border-none cursor-pointer z-20 transition-transform text-xl hover:scale-110 drop-shadow-md">❤️</button>
                      
                      {images.length > 1 && (
                        <>
                          <button onClick={(e) => handleCardImageChange(e, car.id, images.length, -1)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 text-white w-7 h-7 rounded-full flex items-center justify-center opacity-0 group-hover/slider:opacity-100 transition-opacity z-10 hover:bg-[#ef5e33] text-xs border-none cursor-pointer shadow-lg">❮</button>
                          <button onClick={(e) => handleCardImageChange(e, car.id, images.length, 1)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 text-white w-7 h-7 rounded-full flex items-center justify-center opacity-0 group-hover/slider:opacity-100 transition-opacity z-10 hover:bg-[#ef5e33] text-xs border-none cursor-pointer shadow-lg">❯</button>
                          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1 z-10 bg-black/20 px-2 py-1 rounded-full backdrop-blur-sm">
                              {images.map((_, idx) => (
                                <div key={idx} className={`h-1.5 rounded-full transition-all ${currentIndex === idx ? 'w-3 bg-[#ef5e33]' : 'w-1.5 bg-white/70'}`} />
                              ))}
                          </div>
                        </>
                      )}
                    </div>
                    <h3 className="text-base md:text-lg font-black text-[#002f34] uppercase px-2 truncate mb-2">{car.brand} {car.model}</h3>
                    <div className="flex flex-wrap gap-1.5 md:gap-2 px-2 mb-4">
                      {car.year && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{car.year}</span>}
                      {car.kilometers_driven && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{car.kilometers_driven?.toLocaleString()} KM</span>}
                      {getVal(car.fuel_type) && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{getVal(car.fuel_type)}</span>}
                      {getVal(car.transmission) && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{getVal(car.transmission)}</span>}
                    </div>
                    <div className="flex justify-between items-center px-2 mt-auto pb-1">
                      <div className="flex flex-col">
                        <span className="text-[9px] md:text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-0.5">Price</span>
                        <span className="text-lg md:text-xl font-black text-[#002f34] leading-none">₹{car.price?.toLocaleString()}</span>
                      </div>
                      <div className="flex gap-2">
                        <button onClick={(e) => { e.stopPropagation(); handleDirectBuy(car); }} className="bg-[#002f34] text-white font-black text-[10px] md:text-[11px] uppercase px-3 py-1.5 md:px-4 md:py-2 rounded-xl hover:bg-[#ef5e33] transition-colors shadow-lg border-none cursor-pointer">BUY</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="text-center text-gray-400 font-bold mt-10">No new cars arrived in the last 30 days.</p>
          )}
        </main>
        <Footer setView={navigateTo} />
      </div>
    );
  }

  if (view === 'buy') {
    if (isMobile) {
      return (
        <>
          <MobileBuyCar 
            view={view} 
            setView={navigateTo} 
            goBack={goBack}
            cars={cars} 
            searchTerm={searchTerm} 
            setSearchTerm={setSearchTerm} 
            cityFilter={cityFilter} 
            setCityFilter={setCityFilter} 
            setSelectedCar={setSelectedCar}
          />
          <MobileBottomNav view={view} setView={navigateTo} activeTab={activeTab} setActiveTab={setActiveTab} />
        </>
      );
    }
    return <BuyUsedCar view={view} setView={navigateTo} searchTerm={searchTerm} setSearchTerm={setSearchTerm} cityFilter={cityFilter} setCityFilter={setCityFilter} setActiveTab={setActiveTab} setSelectedCar={setSelectedCar} />;
  }
  
  if (view === 'emi') return <EMICalculator view={view} setView={navigateTo} searchTerm={searchTerm} setSearchTerm={setSearchTerm} cityFilter={cityFilter} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />;
  if (view === 'about') return <AboutUs view={view} setView={navigateTo} searchTerm={searchTerm} setSearchTerm={setSearchTerm} cityFilter={cityFilter} setCityFilter={setCityFilter} />;
  if (view === 'faq') return <FAQ view={view} setView={navigateTo} searchTerm={searchTerm} setSearchTerm={setSearchTerm} cityFilter={cityFilter} setCityFilter={setCityFilter} />;
  if (view === 'terms') return <TermsAndCondition view={view} setView={navigateTo} searchTerm={searchTerm} setSearchTerm={setSearchTerm} cityFilter={cityFilter} setCityFilter={setCityFilter} />;
  if (view === 'privacy') return <PrivacyPolicy view={view} setView={navigateTo} searchTerm={searchTerm} setSearchTerm={setSearchTerm} cityFilter={cityFilter} setCityFilter={setCityFilter} />;
  if (view === 'career') return <Career view={view} setView={navigateTo} searchTerm={searchTerm} setSearchTerm={setSearchTerm} cityFilter={cityFilter} setCityFilter={setCityFilter} />;
  if (view === 'contact-us') return <ContactUs view={view} setView={navigateTo} searchTerm={searchTerm} setSearchTerm={setSearchTerm} cityFilter={cityFilter} setCityFilter={setCityFilter} />;
  if (view === 'inspection-process') return <InspectionProcess view={view} setView={navigateTo} searchTerm={searchTerm} setSearchTerm={setSearchTerm} cityFilter={cityFilter} setCityFilter={setCityFilter} />;
  if (view === 'blogs') return <Blogs view={view} setView={navigateTo} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />;

  if (view === 'explore') {
    if (isMobile) {
      return (
        <>
          <MobileExplore view={view} setView={navigateTo} />
          <MobileBottomNav view={view} setView={navigateTo} activeTab={activeTab} setActiveTab={setActiveTab} />
        </>
      );
    }
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 flex-col gap-4">
        <h2 className="text-2xl font-black text-[#002f34]">Explore Page</h2>
        <button onClick={goBack} className="px-6 py-2 bg-[#ef5e33] text-white rounded-lg font-bold border-none cursor-pointer shadow-lg hover:bg-[#d94f29]">Go Back</button>
      </div>
    );
  }

  if (isMobile && view === 'home') {
    return (
      <>
        <MobileHome 
          view={view} 
          setView={navigateTo} 
          cars={cars} 
          newArrivalCars={newArrivalCars} 
          cityFilter={cityFilter}
          setCityFilter={setCityFilter}
          setSelectedCar={setSelectedCar} 
          setSearchTerm={setSearchTerm} 
        />
        <MobileBottomNav view={view} setView={navigateTo} activeTab={activeTab} setActiveTab={setActiveTab} />
      </>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-sans relative">
      
      <style>
        {`
          @keyframes scrollMarquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(calc(-50% - 10px)); } 
          }
          .feedback-marquee-wrapper { display: flex; overflow: hidden; width: 100%; position: relative; padding: 10px 0; }
          .feedback-marquee-track { display: flex; gap: 20px; width: max-content; animation: scrollMarquee 35s linear infinite; }
          .feedback-marquee-track:hover { animation-play-state: paused; }
          .feedback-card { width: 320px; flex-shrink: 0; }
          @media (max-width: 600px) { .feedback-card { width: 280px; } }
          
          .brand-divider-container { display: flex; alignItems: center; textAlign: center; margin: 40px 0 30px; }
          .brand-divider-line { flex: 1; borderBottom: 2px solid #eaeaea; }
          .brand-divider-text { padding: 0 20px; fontSize: 24px; fontWeight: 900; color: #002f34; textTransform: uppercase; fontStyle: italic; }
          @media (max-width: 600px) { .brand-divider-text { fontSize: 20px; } }

          @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
          .mobile-bottom-sheet { animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

          .hide-scrollbar::-webkit-scrollbar { display: none; }
          .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
          
          .shorts-scroll-container::-webkit-scrollbar { display: none; }
          .shorts-scroll-container { -ms-overflow-style: none; scrollbar-width: none; }
        `}
      </style>

      <Header view={view} setView={navigateTo} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />

      <div className="relative h-[250px] sm:h-[350px] md:h-[550px] w-full overflow-hidden bg-black">
        {BANNER_IMAGES.map((img, idx) => (
          <img key={idx} src={img} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${idx === bannerIndex ? 'opacity-100' : 'opacity-0'}`} alt="Premium Car Banner" />
        ))}
        <div className="absolute inset-0 z-10 w-full h-full flex flex-col justify-start pt-4 sm:pt-8 md:pt-16 px-4 md:px-16 bg-gradient-to-b from-black/70 via-black/20 to-transparent md:bg-transparent pointer-events-none">
          <p className="text-[#ef5e33] text-[11px] sm:text-sm md:text-lg font-black max-w-[1200px] drop-shadow-[0_2px_6px_rgba(0,0,0,0.9)] leading-snug">
            Your trusted partner for buying and selling premium used cars. <br className="hidden md:block"/>
            Experience seamless transactions and top-notch service.
          </p>
        </div>
      </div>

      <div className="md:hidden px-4 pt-6 pb-2 w-full max-w-full overflow-hidden">
         <div className="grid grid-cols-3 gap-3">
            <ActionItem label="Buy Used Car" icon={iconBuy} actionType="buy" />
            <ActionItem label="Sell Car" icon={iconSell} actionType="sell" />
            <ActionItem label="New Arrivals" icon={iconNew} actionType="new-arrivals" />
            <ActionItem label="List Car" icon={iconList} actionType="list-car" />
            <ActionItem label="Test Drive" icon={iconDrive} actionType="test-drive" />
            
            <div onClick={openMoreMenu} className="bg-white rounded-xl p-2 flex flex-col items-center justify-center border border-gray-100 shadow-[0_2px_8px_rgba(0,0,0,0.04)] cursor-pointer active:scale-95 transition-transform hover:shadow-md">
              <img src={iconMore} alt="More" className="w-[60px] h-[60px] object-contain mb-1 drop-shadow-sm opacity-80" />
              <span className="text-[10px] font-black text-[#002f34] text-center leading-tight whitespace-nowrap overflow-hidden text-ellipsis w-full">More</span>
            </div>
         </div>
      </div>

      <div className="hidden md:flex justify-center gap-6 pt-10 pb-6 w-full max-w-[1200px] mx-auto">
        {[
          { label: "Buy Used Car", icon: iconBuy, action: "buy" },
          { label: "Sell Car", icon: iconSell, action: "sell" },
          { label: "New Arrivals", icon: iconNew, action: "new-arrivals" },
          { label: "List Car", icon: iconList, action: "list-car" },
          { label: "Test Drive", icon: iconDrive, action: "test-drive" },
        ].map((item, idx) => (
          <div 
            key={idx} 
            onClick={() => handleQuickAction(item.action)} 
            className="bg-white rounded-[1.5rem] p-5 flex flex-col items-center justify-center border border-gray-100 shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-xl cursor-pointer transition-all hover:-translate-y-1 flex-1 max-w-[200px]"
          >
            <img src={item.icon} alt={item.label} className="w-[80px] h-[60px] object-contain mb-3 drop-shadow-sm" />
            <span className="text-sm font-black text-[#002f34] text-center whitespace-nowrap uppercase tracking-wide">{item.label}</span>
          </div>
        ))}
      </div>

      {showMobileMoreMenu && (
        <div className="fixed inset-0 z-[9999] flex flex-col justify-end bg-[#002f34]/60 backdrop-blur-sm md:hidden">
           <div className="absolute inset-0" onClick={closeMoreMenu}></div>
           <div className="mobile-bottom-sheet relative bg-gray-50 w-full rounded-t-[30px] p-6 shadow-2xl flex flex-col max-h-[85vh]">
              <div className="flex justify-between items-center mb-6">
                 <h3 className="font-black text-xl text-[#002f34] m-0 uppercase">All Services</h3>
                 <button onClick={closeMoreMenu} className="bg-gray-200 text-gray-600 border-none w-8 h-8 rounded-full flex items-center justify-center font-bold cursor-pointer">✕</button>
              </div>
              <div className="overflow-y-auto pb-6 -mx-2 px-2">
                 <div className="grid grid-cols-3 gap-4">
                    <ActionItem label="Buy Used Car" icon={iconBuy} actionType="buy" />
                    <ActionItem label="Sell Car" icon={iconSell} actionType="sell" />
                    <ActionItem label="New Arrivals" icon={iconNew} actionType="new-arrivals" />
                    <ActionItem label="List Car" icon={iconList} actionType="list-car" />
                    <ActionItem label="Test Drive" icon={iconDrive} actionType="test-drive" />
                    <ActionItem label="Insurance" icon={iconInsurance} actionType="insurance" />
                    <ActionItem label="Pay Challan" icon={iconChallan} actionType="challan" />
                    <ActionItem label="RTO Check" icon={iconRto} actionType="rto" />
                    <ActionItem label="RC Details" icon={iconRc} actionType="rc" />
                    <ActionItem label="Service History" icon={iconService} actionType="service" />
                 </div>
              </div>
           </div>
        </div>
      )}

      <main className="max-w-[1600px] w-full mx-auto pt-3 md:pt-5 pb-5 md:pb-20 px-4 md:px-8 flex-1 overflow-hidden">
        
        <div className="flex justify-between items-end mb-6 md:mb-10">
           <h2 className="text-2xl md:text-3xl font-black text-[#002f34] uppercase italic">Recommended <span className="text-[#ef5e33]">For You</span></h2>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-6">
          {homepageCars.map((car) => {
            const images = getImages(car.image);
            const currentIndex = cardImageIndex[car.id] || 0;

            return (
              <div key={car.id} onClick={() => { setSelectedCar(car); navigateTo('details'); }} className="bg-white p-3 rounded-[1.5rem] md:rounded-[2rem] shadow-md hover:shadow-2xl transition-all duration-300 group relative flex flex-col cursor-pointer hover:-translate-y-2">
                <div 
                  className="h-40 md:h-44 rounded-[1rem] md:rounded-[1.5rem] mb-3 overflow-hidden relative group/slider"
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={(e) => handleTouchEnd(e, car.id, images.length)}
                >
                  <img src={`https://bahcarplaza.com/api/files/${car.collectionId}/${car.id}/${images[currentIndex]}`} className="w-full h-full object-cover group-hover:scale-110 transition duration-700" alt="car" />
                  <button onClick={(e) => { e.stopPropagation(); handleAddToWishlist(car.id); }} className="absolute top-3 right-3 bg-transparent border-none cursor-pointer z-20 transition-transform text-xl md:text-2xl hover:scale-110 drop-shadow-md">❤️</button>
                  
                  {images.length > 1 && (
                    <>
                      <button onClick={(e) => handleCardImageChange(e, car.id, images.length, -1)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 text-white w-7 h-7 rounded-full flex items-center justify-center opacity-0 group-hover/slider:opacity-100 transition-opacity z-10 hover:bg-[#ef5e33] text-xs border-none cursor-pointer shadow-lg">❮</button>
                      <button onClick={(e) => handleCardImageChange(e, car.id, images.length, 1)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 text-white w-7 h-7 rounded-full flex items-center justify-center opacity-0 group-hover/slider:opacity-100 transition-opacity z-10 hover:bg-[#ef5e33] text-xs border-none cursor-pointer shadow-lg">❯</button>
                      <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1 z-10 bg-black/20 px-2 py-1 rounded-full backdrop-blur-sm">
                          {images.map((_, idx) => (
                            <div key={idx} className={`h-1.5 rounded-full transition-all ${currentIndex === idx ? 'w-3 bg-[#ef5e33]' : 'w-1.5 bg-white/70'}`} />
                          ))}
                      </div>
                    </>
                  )}
                </div>
                <h3 className="text-base md:text-lg font-black text-[#002f34] uppercase px-2 truncate mb-2">{car.brand} {car.model}</h3>
                <div className="flex flex-wrap gap-1.5 md:gap-2 px-2 mb-4">
                  {car.year && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{car.year}</span>}
                  {car.kilometers_driven && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{car.kilometers_driven?.toLocaleString()} KM</span>}
                  {getVal(car.fuel_type) && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{getVal(car.fuel_type)}</span>}
                  {getVal(car.transmission) && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{getVal(car.transmission)}</span>}
                </div>
                <div className="flex justify-between items-center px-2 mt-auto pb-1">
                  <div className="flex flex-col">
                    <span className="text-[9px] md:text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-0.5">Price</span>
                    <span className="text-lg md:text-xl font-black text-[#002f34] leading-none">₹{car.price?.toLocaleString()}</span>
                  </div>
                  <div className="flex gap-2">
                    <button onClick={(e) => { e.stopPropagation(); handleDirectBuy(car); }} className="bg-[#002f34] text-white font-black text-[10px] md:text-[11px] uppercase px-3 py-1.5 md:px-4 md:py-2 rounded-xl hover:bg-[#ef5e33] transition-colors shadow-lg border-none cursor-pointer">BUY</button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {soldOutCars.length > 0 && (
          <section className="mt-16 md:mt-24 pt-8 border-t-2 border-dashed border-gray-200">
            <div className="flex justify-between items-end mb-6 md:mb-10">
               <h2 className="text-2xl md:text-3xl font-black text-[#002f34] uppercase italic">Recently <span className="text-red-600">Sold Out</span></h2>
            </div>
            
            <div className="flex md:grid overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none pb-6 md:pb-0 gap-4 md:gap-6 hide-scrollbar md:grid-cols-3 xl:grid-cols-5">
              {soldOutCars.map((car) => {
                const images = getImages(car.image);
                const currentIndex = cardImageIndex[car.id] || 0;

                return (
                  <div 
                    key={car.id} 
                    onClick={() => { setSelectedCar(car); navigateTo('details'); }} 
                    className="shrink-0 w-[85vw] sm:w-[320px] md:w-auto snap-center md:snap-align-none bg-white p-3 rounded-[1.5rem] md:rounded-[2rem] shadow-md transition-all duration-300 group relative flex flex-col opacity-80 grayscale-[30%] cursor-pointer hover:grayscale-0"
                  >
                    <div 
                      className="h-40 md:h-44 rounded-[1rem] md:rounded-[1.5rem] mb-3 overflow-hidden relative group/slider"
                      onTouchStart={handleTouchStart}
                      onTouchMove={handleTouchMove}
                      onTouchEnd={(e) => handleTouchEnd(e, car.id, images.length)}
                    >
                      <img src={`https://bahcarplaza.com/api/files/${car.collectionId}/${car.id}/${images[currentIndex]}`} className="w-full h-full object-cover" alt="car" />
                      
                      <div className="absolute inset-0 bg-black/40 flex items-center justify-center z-20">
                        <span className="bg-red-600 text-white font-black px-4 py-1.5 rounded-lg border-2 border-white shadow-xl transform -rotate-12 text-lg uppercase tracking-widest">Sold Out</span>
                      </div>
                    </div>
                    <h3 className="text-base md:text-lg font-black text-[#002f34] uppercase px-2 truncate mb-2">{car.brand} {car.model}</h3>
                    <div className="flex flex-wrap gap-1.5 md:gap-2 px-2 mb-4">
                      {car.year && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{car.year}</span>}
                      {car.kilometers_driven && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{car.kilometers_driven?.toLocaleString()} KM</span>}
                      {getVal(car.fuel_type) && <span className="bg-[#f4f7f6] text-[#555] text-[8px] md:text-[9px] font-extrabold px-2 py-1 rounded-md uppercase tracking-wider">{getVal(car.fuel_type)}</span>}
                    </div>
                    <div className="flex justify-between items-center px-2 mt-auto pb-1">
                      <div className="flex flex-col">
                        <span className="text-[9px] md:text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-0.5">Sold At</span>
                        <span className="text-lg md:text-xl font-black text-gray-500 line-through decoration-red-500 decoration-2 leading-none">₹{car.price?.toLocaleString()}</span>
                      </div>
                      <div className="flex gap-2">
                        <button disabled className="bg-gray-300 text-gray-500 font-black text-[10px] md:text-[11px] uppercase px-3 py-1.5 md:px-4 md:py-2 rounded-xl shadow-none border-none cursor-not-allowed">SOLD</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {allBrands.length > 0 && (
          <section id="explore-brands" className="mt-16 md:mt-24 scroll-mt-24">
            <div className="brand-divider-container">
              <div className="flex justify-between items-end mb-6 md:mb-0">
                 <h2 className="text-2xl md:text-3xl font-black text-[#002f34] uppercase italic">Explore <span className="text-[#ef5e33]">Popular Brands</span></h2>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3 mt-4 md:hidden">
              {topPopularBrands.map((brand, index) => (
                <div 
                  key={index} 
                  onClick={() => handleBrandClick(brand.name)}
                  className="bg-white rounded-2xl p-3 flex flex-col items-center justify-center border border-gray-100 shadow-sm hover:shadow-xl cursor-pointer transition-all hover:-translate-y-1"
                >
                  <img src={brand.logo} alt={brand.name} className="w-full h-10 object-contain mb-2 opacity-90 drop-shadow-sm" />
                  <p className="text-[10px] font-black text-[#ef5e33] m-0">{brand.count} Cars</p>
                </div>
              ))}
              
              <div 
                  onClick={openBrandsModal}
                  className="bg-[#f9f9f9] rounded-2xl p-3 flex flex-col items-center justify-center border border-gray-200 shadow-sm hover:shadow-md cursor-pointer transition-all hover:-translate-y-1"
                >
                  <span className="text-2xl mb-1 text-gray-400">•••</span>
                  <p className="text-[10px] font-black text-gray-500 m-0 uppercase">More</p>
              </div>
            </div>

            <div className="hidden md:flex md:flex-wrap gap-3 mt-4">
              {allBrands.map((brand, index) => (
                <div 
                  key={index} 
                  onClick={() => handleBrandClick(brand.name)}
                  className="bg-white rounded-[1rem] p-2 flex flex-col items-center justify-center border border-gray-100 shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-md cursor-pointer transition-all hover:-translate-y-1 w-[90px] lg:w-[100px] xl:w-[110px] shrink-0"
                >
                  <img src={brand.logo} alt={brand.name} className="w-full h-8 object-contain mb-1.5 opacity-90 drop-shadow-sm" />
                  <p className="text-[10px] font-black text-[#ef5e33] m-0 whitespace-nowrap">{brand.count} Cars</p>
                </div>
              ))}
            </div>

            <div className="text-center mt-10">
              <button 
                onClick={() => { setSearchTerm(''); navigateTo('buy'); }} 
                className="bg-transparent border-2 border-[#002f34] text-[#002f34] px-8 md:px-12 py-3 rounded-full font-black text-sm uppercase tracking-wide hover:bg-[#002f34] hover:text-white transition-colors cursor-pointer shadow-sm"
              >
                View All Cars
              </button>
            </div>
          </section>
        )}

        {showBrandsModal && (
          <div className="fixed inset-0 z-[9999] flex flex-col justify-end bg-[#002f34]/60 backdrop-blur-sm md:hidden">
             <div className="absolute inset-0" onClick={closeBrandsModal}></div>
             <div className="mobile-bottom-sheet relative bg-gray-50 w-full rounded-t-[30px] p-6 shadow-2xl flex flex-col max-h-[85vh]">
                <div className="flex justify-between items-center mb-6">
                   <h3 className="font-black text-xl text-[#002f34] m-0 uppercase">All Brands</h3>
                   <button onClick={closeBrandsModal} className="bg-gray-200 text-gray-600 border-none w-8 h-8 rounded-full flex items-center justify-center font-bold cursor-pointer">✕</button>
                </div>
                <div className="overflow-y-auto pb-6 -mx-2 px-2">
                   <div className="grid grid-cols-3 gap-4">
                      {allBrands.map((brand, index) => (
                        <div 
                          key={index} 
                          onClick={() => handleBrandClick(brand.name)}
                          className="bg-white rounded-xl p-3 flex flex-col items-center justify-center border border-gray-100 shadow-[0_2px_8px_rgba(0,0,0,0.04)] cursor-pointer active:scale-95 transition-transform hover:shadow-md"
                        >
                          <img src={brand.logo} alt={brand.name} className="w-full h-10 object-contain mb-2 opacity-90 drop-shadow-sm" />
                          <p className="text-[10px] font-black text-[#ef5e33] m-0">{brand.count} Cars</p>
                        </div>
                      ))}
                   </div>
                </div>
             </div>
          </div>
        )}

        {videosList.length > 0 && (
          <section className="mt-16 md:mt-8">
            <div className="brand-divider-container">
              <div className="flex justify-between items-end mb-6 md:mb-0">
                 <h2 className="text-2xl md:text-3xl font-black text-[#002f34] uppercase italic">Watch Our <span className="text-[#ef5e33]">Shorts</span></h2>
              </div>
            </div>

            <div className="relative group mt-4">
              <button 
                onClick={() => scrollVideos('left')} 
                className="hidden md:flex absolute left-2 top-1/2 -translate-y-1/2 z-20 bg-white/90 backdrop-blur-sm text-[#002f34] w-12 h-12 rounded-full items-center justify-center shadow-[0_4px_15px_rgba(0,0,0,0.15)] border border-gray-100 hover:bg-[#ef5e33] hover:text-white hover:border-[#ef5e33] transition-all cursor-pointer text-xl font-black opacity-0 group-hover:opacity-100"
              >
                ❮
              </button>

              <div ref={videoScrollRef} className="shorts-scroll-container flex overflow-x-auto gap-4 pb-4 snap-x snap-mandatory scroll-smooth">
                {videosList.map((video) => (
                  <div key={video.id} className="shrink-0 w-[240px] md:w-[280px] aspect-[9/16] rounded-[20px] overflow-hidden shadow-lg snap-center bg-gray-900 border border-gray-200 relative">
                    {video.platform === 'YouTube' && (
                      <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${video.video_id}`} title="YouTube Short" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    )}
                    {video.platform === 'Instagram' && (
                      <iframe src={`https://www.instagram.com/p/${video.video_id}/embed`} width="100%" height="100%" frameBorder="0" scrolling="no" allowTransparency="true" allow="encrypted-media"></iframe>
                    )}
                    {video.platform === 'Facebook' && (
                      <iframe src={`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(video.original_url)}&show_text=false`} width="100%" height="100%" style={{border:'none', overflow:'hidden'}} scrolling="no" frameBorder="0" allowFullScreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                    )}
                  </div>
                ))}
              </div>

              <button 
                onClick={() => scrollVideos('right')} 
                className="hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 z-20 bg-white/90 backdrop-blur-sm text-[#002f34] w-12 h-12 rounded-full items-center justify-center shadow-[0_4px_15px_rgba(0,0,0,0.15)] border border-gray-100 hover:bg-[#ef5e33] hover:text-white hover:border-[#ef5e33] transition-all cursor-pointer text-xl font-black opacity-0 group-hover:opacity-100"
              >
                ❯
              </button>

            </div>
          </section>
        )}

        <section className="mt-16 md:mt-24 pb-10 md:pb-16 w-full max-w-full overflow-hidden">
           <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 md:mb-10 px-2 md:px-6 gap-4">
             <h2 className="text-2xl md:text-3xl font-black text-[#002f34] uppercase italic">What Our <span className="text-[#ef5e33]">Customers Say</span></h2>
             <button onClick={() => { if(pb.authStore.isValid) setShowFeedbackModal(true); else { alert("Please login to give feedback."); navigateTo('auth'); } }}
               className="px-6 py-3 bg-[#002f34] text-white border-none rounded-full font-black text-xs md:text-sm uppercase cursor-pointer shadow-lg hover:bg-[#ef5e33] transition-all hover:scale-105 whitespace-nowrap">
               💬 Give Your Feedback
             </button>
           </div>
           
           <div className="feedback-marquee-wrapper">
             <div className="feedback-marquee-track">
                {feedbacks.length > 0 ? [...feedbacks, ...feedbacks].map((fb, index) => {
                  const user = fb.expand?.user_id;
                  if (!user) return null;
                  return (
                    <div key={`${fb.id}-${index}`} className="feedback-card bg-white p-5 rounded-[20px] border border-gray-100 flex flex-col gap-4 shadow-sm hover:shadow-xl transition-shadow">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 md:w-12 md:h-12 bg-[#ef5e33] rounded-full flex items-center justify-center text-white font-black text-base md:text-lg overflow-hidden shrink-0 shadow-sm border border-[#ef5e33]">
                          {user.avatar ? <img src={`https://bahcarplaza.com/api/files/${user.collectionId}/${user.id}/${user.avatar}`} className="w-full h-full object-cover" alt={user.name} /> : (user.name?.charAt(0).toUpperCase() || 'U')}
                        </div>
                        <div className="overflow-hidden">
                          <h4 className="m-0 font-black text-[#002f34] text-xs md:text-sm uppercase truncate">{user.name || 'Anonymous User'}</h4>
                          <p className="m-0 mt-0.5 text-[9px] md:text-[10px] text-gray-400 font-bold">{new Date(fb.created).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
                        </div>
                      </div>
                      <div className="relative">
                        <span className="text-4xl text-[#ef5e33] opacity-20 absolute -top-3 -left-1 font-serif leading-none">“</span>
                        <p className="m-0 text-gray-600 text-xs md:text-sm leading-relaxed font-medium italic relative z-10 pl-2 line-clamp-3">{fb.feedback_text}</p>
                      </div>
                    </div>
                  );
                }) : (
                  <p className="text-center text-gray-400 font-bold w-full py-10">No reviews yet. Be the first to give feedback!</p>
                )}
             </div>
           </div>
        </section>
      </main>

      {/* DESKTOP DETAILS MODAL (STAYS SAME) */}
      {view === 'details' && selectedCar && !isMobile && (() => {
        const detailsImages = getImages(selectedCar.image);
        const isSold = selectedCar.status === 'Sold'; 

        return (
          <div className="fixed inset-0 bg-[#f4f7f6] z-[60] overflow-y-auto w-full h-full">
            <Header view={view} setView={navigateTo} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />
            <div className="max-w-[1400px] w-full mx-auto py-6 md:py-12 px-4 md:px-8 flex flex-col lg:flex-row gap-8">
               <div className="w-full lg:w-2/3">
                  <button onClick={goBack} className="text-[#ef5e33] font-black border-none bg-transparent cursor-pointer text-xs md:text-sm mb-4 md:mb-6 flex items-center gap-1.5 uppercase hover:underline">← Back</button>
                  
                  <div 
                    className={`relative w-full h-[250px] sm:h-[400px] md:h-[500px] rounded-[20px] md:rounded-[40px] shadow-lg overflow-hidden group ${isSold ? 'grayscale-[30%]' : ''}`}
                    onTouchStart={handleDetailsTouchStart}
                    onTouchMove={handleDetailsTouchMove}
                    onTouchEnd={() => handleDetailsTouchEnd(detailsImages.length)}
                  >
                    <img src={`https://bahcarplaza.com/api/files/${selectedCar.collectionId}/${selectedCar.id}/${detailsImages[detailsImageIndex]}`} className="w-full h-full object-cover transition-opacity duration-500" alt="Car" />
                    
                    {isSold && (
                      <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-20">
                        <span className="bg-red-600 text-white font-black px-6 py-2 rounded-xl border-4 border-white shadow-2xl transform -rotate-12 text-3xl uppercase tracking-widest">Sold Out</span>
                      </div>
                    )}

                    {detailsImages.length > 1 && !isSold && (
                      <>
                        <button onClick={() => setDetailsImageIndex((prev) => (prev - 1 + detailsImages.length) % detailsImages.length)} className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 text-white w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center hover:bg-[#ef5e33] transition-colors z-10 text-lg md:text-xl border-none cursor-pointer shadow-lg opacity-80 hover:opacity-100">❮</button>
                        <button onClick={() => setDetailsImageIndex((prev) => (prev + 1) % detailsImages.length)} className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 text-white w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center hover:bg-[#ef5e33] transition-colors z-10 text-lg md:text-xl border-none cursor-pointer shadow-lg opacity-80 hover:opacity-100">❯</button>

                        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10 bg-black/40 px-3 py-2 rounded-full backdrop-blur-sm">
                          {detailsImages.map((_, idx) => (
                            <div key={idx} onClick={() => setDetailsImageIndex(idx)} className={`h-2.5 rounded-full cursor-pointer transition-all ${detailsImageIndex === idx ? 'w-6 bg-[#ef5e33]' : 'w-2.5 bg-white/70 hover:bg-white'}`} />
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                  
                  <div className="mt-6 md:mt-10 p-6 md:p-12 bg-white rounded-[20px] md:rounded-[40px] shadow-sm border border-gray-100">
                     <h2 className="text-xl md:text-2xl font-black mb-6 md:mb-8 text-[#002f34] uppercase">Technical Specifications</h2>
                     <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 md:gap-8">
                        {[ { label: 'Mfg Year', val: selectedCar.year }, { label: 'Fuel Type', val: getVal(selectedCar.fuel_type) }, { label: 'Location', val: getVal(selectedCar.city) }, { label: 'Transmission', val: getVal(selectedCar.transmission) }, { label: 'Mileage', val: `${selectedCar.mileage} KMPL` }, { label: 'Owner', val: selectedCar.owner_type }, { label: 'Color', val: getVal(selectedCar.color) } ].map((spec, i) => (
                          <div key={i}>
                            <p className="text-gray-400 text-[9px] md:text-[11px] font-black m-0 mb-1.5 uppercase tracking-wide">{spec.label}</p>
                            <p className="font-black m-0 text-sm md:text-lg text-[#002f34] truncate">{spec.val}</p>
                          </div>
                        ))}
                     </div>
                  </div>
               </div>

               <div className="w-full lg:w-1/3">
                  <div className="p-6 md:p-10 bg-white rounded-[20px] md:rounded-[40px] lg:sticky lg:top-[120px] shadow-sm border border-gray-100">
                     <h1 className="text-3xl md:text-4xl lg:text-[42px] font-black text-[#002f34] m-0 mb-2 uppercase leading-tight">{selectedCar.brand} <br/><span className="text-[#ef5e33]">{selectedCar.model}</span></h1>
                     <p className="text-gray-500 font-bold text-xs md:text-sm mb-6 md:mb-8">{selectedCar.year} • {selectedCar.kilometers_driven?.toLocaleString()} KM Driven</p>
                     
                     <div className="bg-[#f4f7f6] p-5 md:p-8 rounded-[15px] md:rounded-[25px] mb-6 md:mb-8 border border-gray-200">
                        <p className="text-[9px] md:text-[11px] font-black text-gray-400 m-0 mb-2 uppercase tracking-widest">Fixed Price</p>
                        <h2 className="text-3xl md:text-[42px] font-black text-[#002f34] m-0">₹{selectedCar.price?.toLocaleString()}</h2>
                     </div>
                     
                     <div className="flex flex-col gap-3 md:gap-4">
                        {isSold ? (
                          <button disabled className="w-full py-4 md:py-5 bg-gray-300 text-gray-500 border-none rounded-xl md:rounded-2xl font-black text-sm md:text-base cursor-not-allowed uppercase tracking-wide">🚫 OUT OF STOCK</button>
                        ) : (
                          <button onClick={handleBuyNowSubmit} className="w-full py-4 md:py-5 bg-[#1db954] text-white border-none rounded-xl md:rounded-2xl font-black text-sm md:text-base cursor-pointer shadow-lg hover:scale-105 transition-transform uppercase tracking-wide">⚡ BUY NOW</button>
                        )}
                        <button onClick={() => { if(pb.authStore.isValid) setShowBookingModal(true); else navigateTo('auth'); }} className="w-full py-4 md:py-5 bg-[#002f34] text-white border-none rounded-xl md:rounded-2xl font-black text-sm md:text-base cursor-pointer hover:scale-105 transition-transform uppercase tracking-wide">🗓️ SCHEDULE VISIT</button>
                        <button onClick={() => handleAddToWishlist(selectedCar.id)} className="w-full py-4 md:py-5 bg-white border-2 border-gray-200 text-[#002f34] rounded-xl md:rounded-2xl font-black text-sm md:text-base cursor-pointer hover:bg-gray-50 transition-colors uppercase tracking-wide">❤️ ADD TO WISHLIST</button>
                     </div>
                  </div>
               </div>
            </div>
          </div>
        );
      })()}

      {showBookingModal && (
        <div className="fixed inset-0 bg-[#002f34]/80 z-[1000] flex items-center justify-center p-4 backdrop-blur-sm">
          <div className="bg-white w-full max-w-[550px] rounded-3xl md:rounded-[40px] p-6 md:p-10 shadow-2xl">
             <div className="flex justify-between items-center mb-6 md:mb-8">
                <h2 className="font-black text-xl md:text-3xl text-[#002f34] m-0 uppercase">Book Visit</h2>
                <button onClick={() => setShowBookingModal(false)} className="bg-gray-100 border-none font-bold cursor-pointer text-black w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center text-sm md:text-base hover:bg-gray-200">✕</button>
             </div>
             <form onSubmit={handleBookingSubmit} className="flex flex-col gap-3 md:gap-4">
                <input required type="text" placeholder="Full Name" style={inputStyle} onChange={(e) => setBookingData({...bookingData, full_name: e.target.value})} />
                <input required type="number" placeholder="Phone Number" style={inputStyle} onChange={(e) => setBookingData({...bookingData, phone: e.target.value})} />
                <input required type="datetime-local" style={inputStyle} onChange={(e) => setBookingData({...bookingData, booking_date: e.target.value})} />
                <select style={inputStyle} onChange={(e) => setBookingData({...bookingData, visit_type: e.target.value})}>
                  <option value="Test Drive">Test Drive</option>
                  <option value="Inspection">Inspection</option>
                </select>
                <textarea placeholder="Message (Optional)..." style={{ ...inputStyle, height: '80px', resize: 'none' }} onChange={(e) => setBookingData({...bookingData, message: e.target.value})} />
                <button type="submit" className="p-4 md:p-5 bg-[#ef5e33] text-white border-none rounded-xl md:rounded-2xl font-black uppercase cursor-pointer mt-2 text-sm md:text-base shadow-lg hover:bg-[#d94f29] transition-colors">Confirm Booking</button>
             </form>
          </div>
        </div>
      )}

      {showFeedbackModal && (
        <div className="fixed inset-0 bg-[#002f34]/80 z-[1000] flex items-center justify-center p-4 backdrop-blur-sm">
          <div className="bg-white w-full max-w-[550px] rounded-3xl md:rounded-[40px] p-6 md:p-10 shadow-2xl">
             <div className="flex justify-between items-center mb-6 md:mb-8">
                <h2 className="font-black text-xl md:text-3xl text-[#002f34] m-0 uppercase leading-tight">Share Your <br className="hidden md:block"/>Experience</h2>
                <button onClick={() => setShowFeedbackModal(false)} className="bg-gray-100 border-none font-bold cursor-pointer text-black w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center text-sm md:text-base hover:bg-gray-200 shrink-0 ml-2">✕</button>
             </div>
             <form onSubmit={handleFeedbackSubmit} className="flex flex-col gap-3 md:gap-4">
                <p className="m-0 text-gray-500 font-semibold text-xs md:text-sm">Logged in as: <span className="text-[#ef5e33] font-black">{pb.authStore.model?.name}</span></p>
                <textarea required placeholder="Type your valuable feedback here... (Min 5 chars)" value={newFeedback} style={{ ...inputStyle, height: '120px', resize: 'none' }} className="text-sm leading-relaxed" onChange={(e) => setNewFeedback(e.target.value)} />
                <button type="submit" className="p-4 md:p-5 bg-[#ef5e33] text-white border-none rounded-xl md:rounded-2xl font-black uppercase cursor-pointer mt-2 text-sm md:text-base shadow-lg hover:bg-[#d94f29] transition-colors">Submit Feedback</button>
             </form>
          </div>
        </div>
      )}

      <Footer setView={navigateTo} />
    </div>
  );
}

export default App;